import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import ConnectAPI from '../../../services/api';
import {
  numberFormatCommaMinimunFraction,
  numberFormatComma,
} from '../../../common/js/utils/numberFormat';
import Swal from 'sweetalert2';
import { Trans } from 'react-i18next';

const OMPRate = (props) => {
  const connectApi = new ConnectAPI();
  const [ompByChannel, setOmpByChannel] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
        if (ur==window.location.pathname){
            validate=true;
        }
    });
    if (validate==false){
        const { history } = props;
        history.push({
            pathname: '/' 
        });
    }
    //end validate
    setIsLoading(true);

    const fetchData = async () => {
      connectApi
        .get(
          'api/Channels/OmpRateByChannel',
          {
            params: {
              customerId: null,
            },
          },
          dataResponseLoad
        )
        .catch((error) => {
          setIsLoading(false);
          Swal.fire(
            'Error ' + error.response.status,
            error.response.data,
            'error'
          );
        });
    };

    const dataResponseLoad = (status, data) => {
      //console.log(data);
      // data.map((item, key) => {
      //   item.id = key;
      //   item.priceFormatted =
      //     item.price == null ? '-' : numberFormatComma(item.price);
      // });

      setOmpByChannel(data === undefined ? [] : data);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const digiPixTable = (
    <div>
      <br />
      <p>
       <h6><b>Digipix</b></h6>
      </p>
      <br />
      <div>
        <div style={{ display: 'inline-block', padding: '0.5%' }}>
          <table className="table table-striped table-hover table-bordered table-sm table-fit table-card-head">
            <thead>
              <tr>
                <th><Trans i18nKey="pricelist.table.presstype" /></th>
                <th><Trans i18nKey="series" /></th>
                <th><Trans i18nKey="tax" /></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>w7250</td>
                <td>3</td>
                <td>0.09888</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  const byModelTable = (
    <div>
      <br />
      <p>
      <h6><b><Trans i18nKey="omprate.notes1" /></b></h6>
      </p>
      <br />

      <div
        style={{
          display: 'inline-block',
          width: '230px',
          padding: '0.5%',
          verticalAlign: 'top',
        }}
      >
        <table className="table table-striped table-hover table-bordered table-sm table-fit table-card-head">
          <thead>
            <tr>
              <th><Trans i18nKey="pricelist.table.presstype" /></th>
              <th><Trans i18nKey="series" /></th>
              <th><Trans i18nKey="tax" /></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>10000</td>
              <td>4</td>
              <td>0.094900</td>
            </tr>
            <tr>
              <td>12000</td>
              <td>4</td>
              <td>0.094900</td>
            </tr>
            <tr>
              <td>20000</td>
              <td>4</td>
              <td>0.043600</td>
            </tr>
            <tr>
              <td>30000</td>
              <td>4</td>
              <td>0.043600</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style={{ display: 'inline-block', width: '70%', padding: '0.5%' }}>
        <table className="table table-striped table-hover table-bordered table-sm table-fit table-card-head">
          <thead>
            <tr>
              <th><Trans i18nKey="pricelist.table.presstype" /></th>
              <th><Trans i18nKey="series" /></th>
              <th><Trans i18nKey="tax" /></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>10000</td>
              <td>4</td>
              <td>
                0.158000
                <font color="red">(Tax until July/2016)</font>
              </td>
            </tr>
            <tr>
              <td>10000</td>
              <td>4</td>
              <td>
                0.140000
                <font color="red">(Tax until June/2017)</font>
              </td>
            </tr>
            <tr>
              <td>20000</td>
              <td>4</td>
              <td>
                0.140000
                <font color="red">(Tax until June/2017)</font>
              </td>
            </tr>
            <tr>
              <td>20000</td>
              <td>4</td>
              <td>
                0.178000
                <font color="red">(Tax until July/2016)</font>
              </td>
            </tr>
            <tr>
              <td>30000</td>
              <td>4</td>
              <td>
                0.186000
                <font color="red">(Tax until July/2016)</font>
              </td>
            </tr>
            <tr>
              <td>30000</td>
              <td>4</td>
              <td>
                0.140000
                <font color="red">(Tax until June/2017)</font>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );

  const byChannelTable = (
    <div>
      <br />
      <p>
      <h6><b><Trans i18nKey="omprate.notes2" /></b></h6>
      </p>
      <br />
      <div>
        <div style={{ display: 'inline-block', padding: '0.5%' }}>
          <table className="table table-striped table-hover table-bordered table-sm table-fit table-card-head">
            <thead>
              <tr>
                <th><Trans i18nKey="channel" /></th>
                <th><Trans i18nKey="series" /> 1 / Commercial</th>
                <th><Trans i18nKey="series" /> 1 / Industrial</th>
                <th><Trans i18nKey="series" /> 2 / Commercial</th>
                <th><Trans i18nKey="series" /> 2 / Industrial</th>
                <th><Trans i18nKey="series" /> 3 / Commercial</th>
                <th><Trans i18nKey="series" /> 3 / Industrial</th>
              </tr>
            </thead>
            <tbody>
              {ompByChannel.map((row) => (
                <tr key={row.idCustomer}>
                  <td>{row.customerName}</td>
                  <td align="right">
                    {row.series1Commercial == null
                      ? '-'
                      : numberFormatCommaMinimunFraction(row.series1Commercial)}
                  </td>
                  <td align="right">
                    {row.series1Industrial == null
                      ? '-'
                      : numberFormatCommaMinimunFraction(row.series1Industrial)}
                  </td>
                  <td align="right">
                    {row.series2Commercial == null
                      ? '-'
                      : numberFormatCommaMinimunFraction(row.series2Commercial)}
                  </td>
                  <td align="right">
                    {row.series2Industrial == null
                      ? '-'
                      : numberFormatCommaMinimunFraction(row.series2Industrial)}
                  </td>
                  <td align="right">
                    {row.series1Commercial == null
                      ? '-'
                      : numberFormatCommaMinimunFraction(row.series1Commercial)}
                  </td>
                  <td align="right">
                    {row.series3Industrial == null
                      ? '-'
                      : numberFormatCommaMinimunFraction(row.series3Industrial)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {digiPixTable}
      {byModelTable}
      {byChannelTable}
    </div>
  );
};

export default withTranslation()(OMPRate);
